import React from 'react';
import { getElementComponent, isComplexElement } from '../ContentElements';
import Accordion from 'src/ui/library/Accordion';
/*
 *  Example Element Structure:
 *
 *   Accordion {
 *     accordionRow: [
 *        { accordionElement: {}, otherData }
 *        { accordionElement: {}, otherData }
 *     ]
 *   }
 *
 *
 */

function AccordionFactory(data, parserFn, currentElements, elementActions) {
  if (!data.accordionRow) {
    throw Error('AccordionFactory: missing `accordionRow` property');
  }

  let accordionElements = [];
  let accordionChildren = [];
  let accordionSections = [];

  data.accordionRow.forEach((row, rowIndex) => {
    const { accordionElement } = row;

    if (!accordionElement) {
      throw Error('AccordionFactory: `accordionRow` missing `accordionElement` property');
    }

    const panelProps = {
      id: row.elementName,
      name: row.elementName,
      label: row.displayText,
    };

    const extractedElements = parserFn([accordionElement], [], false);
    accordionElements = accordionElements.concat(...extractedElements);
    accordionSections.push(panelProps);

    /*
     * If the `accordionElement` is a complex element (aka factory) type then return
     * ONLY that single factory React component. Any children should be rendered by the component factory.
     */
    if (isComplexElement(accordionElement.elementType)) {
      accordionChildren.push(getElementComponent(extractedElements[0], 0));
    } else {
      extractedElements.forEach((el, index) => {
        accordionChildren.push(getElementComponent(el, index));
      });
    }
  });

  const AccordionControl = props => {
    return (
      <Accordion styleType={'questionnaire'} sections={accordionSections} {...props}>
        {accordionChildren}
      </Accordion>
    );
  };

  return { elements: accordionElements, component: AccordionControl };
}

export default AccordionFactory;
